import { userFileGenerationAgent } from 'src/api/userFileGenerationAgent';
import { throwApiError } from 'src/api/utils';

export type UserExportTaskStatus = 'PROCESSING' | 'COMPLETED' | 'FAILED';

export type UserExportTaskResponse = {
  taskId: string;
  wellName: string;
  fileName?: string;
  fileSize?: number;
  status: UserExportTaskStatus;
  createdAt: string;
  completedAt?: string;
  downloadLink?: string;
  errorMessage?: string;
};

export class UserFileGenerationApi {
  async fetchTasks(): Promise<UserExportTaskResponse[]> {
    try {
      const response = await userFileGenerationAgent.get<UserExportTaskResponse[]>('export/csv/tasks');

      return response.data;
    } catch (error) {
      throwApiError(error);
    }
  }

  async fetchTask(taskId: string): Promise<UserExportTaskResponse> {
    try {
      const response = await userFileGenerationAgent.get<UserExportTaskResponse>(`export/csv/tasks/${taskId}`);

      return response.data;
    } catch (error) {
      throwApiError(error);
    }
  }
}
